// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3yr8r","savePackageButton":"ClientWallet_savePackageButton__L4xT_"};